import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import {
  PODisclaimerLabel,
  type PODisclaimerLabelConstructor,
} from '@webapp/modules/purchasing/entities/PODisclaimerLabel'
import { poDisclaimerLabelQueryConfig } from '@webapp/modules/purchasing/query-configs/poDisclaimerLabel'

export interface PODisclaimerLabelListParams {
  page: number
  pageSize: number
}

type UseQueryPODisclaimerLabelsReturn = {
  labels: PODisclaimerLabel[]
  pagination: {
    count: number
    numPages: number
    currentPage: number
  }
  isLoading: boolean
  isFetching: boolean
  error: RepoError | null
}

export const useQueryPODisclaimerLabels = (
  params: PODisclaimerLabelListParams
): UseQueryPODisclaimerLabelsReturn => {
  const { data, isLoading, isFetching, error } = useQuery<
    RepoPaginatedResponse<PODisclaimerLabelConstructor>,
    RepoError
  >(poDisclaimerLabelQueryConfig.list(params))

  const labels = useMemo(
    () => (data?.data ?? []).map((label) => new PODisclaimerLabel(label)),
    [data]
  )

  return {
    labels,
    pagination: {
      count: data?.pagination?.count ?? 0,
      numPages: data?.pagination?.numPages ?? 0,
      currentPage: data?.pagination?.page ?? params.page,
    },
    isLoading,
    isFetching,
    error: error ?? null,
  }
}
